<template>
  <div
    class="dyrs-font-icon-button"
    @click="handleClick($event)"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    :type="type"
    :style="{
      border: border
        ? disabled
          ? '1px solid ' + predefinedColorMap['disable']
          : !isHover
          ? '1px solid ' + hoverBackgroundColor
          : '1px solid transparent'
        : '1px solid transparent',
      background:
        !disabled && isHover
          ? hoverBackgroundColor
          : normalStateBackGroundColor,
      'border-radius': weight / 2 + 'px',
      width: weight + 'px',
      height: weight + 'px',
      'line-height': weight - 2 + 'px',
      cursor: disabled ? 'not-allowed' : '',
    }"
  >
    <i
      v-if="elementIcon"
      :class="icon"
      :style="{
        color: disabled
          ? predefinedColorMap['disable-color']
          : isHover
          ? 'white'
          : hoverBackgroundColor,
      }"
    ></i>
    <font-awesome-icon
      v-else
      :icon="icon"
      :style="{
        'margin-left': weight / 4 - 1 + 'px',
        'margin-top': weight / 4 - 1 + 'px',
        width: weight / 2 + 'px',
        height: weight / 2 + 'px',
        color: disabled
          ? predefinedColorMap['disable-color']
          : isHover
          ? 'white'
          : hoverBackgroundColor,
      }"
    ></font-awesome-icon>
  </div>
</template>

<script>
export default {
  props: {
    weight: {
      type: Number,
      default: 24,
    },
    border: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
    },
    type: {
      type: String,
      default: "primary",
    },
    color: {
      type: String,
      default: "white",
    },
    colorful: {
      type: Boolean,
      default: false,
    },
    elementIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHover: false,
      predefinedColorMap: {
        disable: "#c0c9db",
        "disable-color": "#c0c9db",
        primary: "#409eff",
        primaryColorful: "rgb(237,245,255)",
        danger: "#f56c6c",
        dangerColorful: "rgb(254,240,240)",
        success: "#67c23a",
        successColorful: "rgb(240,249,236)",
        info: "#909399",
        infoColorful: "rgb(244,244,245)",
        warning: "#e6a23c",
        warningColorful: "rgb(253,246,237)",
      },
    };
  },
  methods: {
    handleMouseEnter() {
      this.isHover = true;
    },
    handleMouseLeave() {
      this.isHover = false;
    },

    handleClick(ev) {
      if (this.disabled) return;
      this.$emit("click", ev);
    },
  },
  computed: {
    normalStateBackGroundColor() {
      return this.colorful
        ? this.predefinedColorMap[`${this.type}Colorful`]
        : "white";
    },
    hoverBackgroundColor() {
      let curColor = null;
      if (this.type && this.predefinedColorMap[this.type]) {
        curColor = this.predefinedColorMap[this.type];
      }
      if (!curColor) {
        curColor = this.color || this.predefinedColorMap["primary"];
      }

      return curColor;
    },
  },
};
</script>

<style>
div {
  cursor: not-all;
}
</style>